import { styled } from "@acko-tech/building-blocks.ui.common";

export const BannerContainer = styled.div<{ type?: string }>`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid #FDDFC1;
  background: linear-gradient(78deg, #FFE9D9 -92.23%, #FFF 134.02%);
  width: 100%;

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const BannerHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const BannerText = styled.div`
  color: linear-gradient(269deg, #88613A -10.35%, #E4833D 106.34%);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;


export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;

export const ListItemIcon = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  padding: 0.667px 2px 2.444px 2px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  aspect-ratio: 1/1;
`;

export const ListItemText = styled.div`
  color: var(--Neutral-N500, #36354C);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  flex: 1;
  margin-left: 6px;
  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
